import {
  LayoutDashboard,
  Users,
  FileText,
  ShoppingCart,
  Receipt,
  FolderKanban,
  Package,
  Settings,
  PlusCircle,
  Calendar,
  CalendarDays,
  Target,
  StickyNote,
  Mail,
  Activity,
  UserCheck,
  Truck,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  title: string;
  href: string;
  icon: LucideIcon;
  badge?: string | number;
  items?: NavItem[];
}

export interface NavGroup {
  title: string;
  items: NavItem[];
}

export const sidebarData: NavGroup[] = [
  {
    title: "Général",
    items: [
      {
        title: "Tableau de bord",
        href: "/",
        icon: LayoutDashboard,
      },
    ],
  },
  {
    title: "Commercial",
    items: [
      {
        title: "Tiers",
        href: "/tiers",
        icon: Users,
        items: [
          {
            title: "Clients",
            href: "/tiers?type=client",
            icon: UserCheck,
          },
          {
            title: "Fournisseurs",
            href: "/tiers?type=supplier",
            icon: Truck,
          },
          {
            title: "Nouveau",
            href: "/tiers/nouveau",
            icon: PlusCircle,
          },
        ],
      },
      {
        title: "Devis",
        href: "/devis",
        icon: FileText,
        items: [
          {
            title: "Liste",
            href: "/devis",
            icon: FileText,
          },
          {
            title: "Nouveau",
            href: "/devis/nouveau",
            icon: PlusCircle,
          },
        ],
      },
      {
        title: "Factures",
        href: "/factures",
        icon: Receipt,
      },
    ],
  },
  {
    title: "CRM",
    items: [
      {
        title: "Prospects",
        href: "/crm/prospects",
        icon: Target,
      },
      {
        title: "Notes",
        href: "/crm/notes",
        icon: StickyNote,
      },
      {
        title: "Mail",
        href: "/crm/mail",
        icon: Mail,
      },
      {
        title: "Actions",
        href: "/crm/actions",
        icon: Activity,
      },
    ],
  },
  {
    title: "Projets",
    items: [
      {
        title: "Chantiers",
        href: "/chantiers",
        icon: FolderKanban,
        items: [
          {
            title: "Liste",
            href: "/chantiers",
            icon: FolderKanban,
          },
          {
            title: "Nouveau",
            href: "/chantiers/nouveau",
            icon: PlusCircle,
          },
        ],
      },
      {
        title: "Calendrier",
        href: "/calendrier",
        icon: Calendar,
      },
    ],
  },
  {
    title: "Stock & Achats",
    items: [
      {
        title: "Produits",
        href: "/produits",
        icon: Package,
      },
      {
        title: "Commandes fournisseurs",
        href: "/commandes-fournisseurs",
        icon: ShoppingCart,
        items: [
          {
            title: "Liste",
            href: "/commandes-fournisseurs",
            icon: ShoppingCart,
          },
          {
            title: "Nouvelle",
            href: "/commandes-fournisseurs/nouveau",
            icon: PlusCircle,
          },
        ],
      },
    ],
  },
  {
    title: "Configuration",
    items: [
      {
        title: "Paramètres",
        href: "/parametres",
        icon: Settings,
      },
    ],
  },
];

export const quickActions = [
  {
    title: "Nouveau devis",
    href: "/devis/nouveau",
    icon: FileText,
    description: "Créer un nouveau devis",
    color: "bg-blue-500",
  },
  {
    title: "Nouveau client",
    href: "/tiers/nouveau",
    icon: Users,
    description: "Ajouter un nouveau tiers",
    color: "bg-green-500",
  },
  {
    title: "Nouveau chantier",
    href: "/chantiers/nouveau",
    icon: FolderKanban,
    description: "Créer un projet",
    color: "bg-purple-500",
  },
];
